<template>
  <div id="app" class="bg_box">

    <router-view />
   
  </div>
</template>
<script>

export default {
  data() {
    return {
   
    }
  },
  methods: {
 
  },
  created() {
  }

}
</script>
<!--<style  lang="scss">-->
//.el-message__icon {
// display: none  !important;
//}
//.el-message {
//  background: radial-gradient(circle at center, #041137, #061047, #05336b) !important;
//  border: 1px solid #1a51ac !important;
//}
//.el-message__content {
//  color: white !important;
//}

<!--</style>-->


<style lang="scss" >

.el-dropdown-menu{
  border:1px solid #1155a2 !important;
  background-color: #071858 !important;
}
.el-dropdown-menu__item{
  color: white !important;
}
.popper__arrow::after {
  border-bottom-color:  #071858 !important;
}
.el-dropdown-menu__item:not(.is-disabled):hover{
  background-color: #0076fa !important;
}

.el-message__icon {
  display: none !important;
}

.el-message {
  width: 400px;
  height: 200px;
  background: url(./assets/message_bg.png) no-repeat;
  background-size: 100% 100%;
  background-color: transparent !important;
  border: none !important;
  border-radius: 20px;

}

.el-message--info {
  background-color: transparent !important;
}

.el-message--warning {
  background-color: transparent !important;
}

.el-message__content {
  color: white !important;
}

</style>